export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/turretTableCalculator.848070be.worker.js");
}
